window.addEventListener('load', function () {
  var glide = new Glide('.glide', {
    type: 'carousel',
    startAt: 0,
    perView: 3.4,
    gap: 24,
    bound: true,
    breakpoints: {
      1200: {
        perView: 2.4,
        gap: 8
      },
      767: {
        perView: 1.4,
        slideWidth: 300
      }
    }
  });
  glide.mount()
});